<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    *ngPermissions="[permissionService.Permission.ssp_list,permissionService.Permission.ssp_contract_create]"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="createContract()"
    sbTooltip="{{ 'lang.globals.createContract' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    *ngPermissions="permissionService.Permission.ssp_list"
    type="button"
    sb-button-primary
    [color]="'blue'"
    [icon]="'steleAttributes'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="openSSPs()"
    sbTooltip="{{ 'lang.globals.showSSP' | translate }}"
  >
  </button>

  <button
    *ngPermissions="permissionService.Permission.deal_list"
    type="button"
    sb-button-primary
    [color]="'blue'"
    [icon]="'budgetCoin'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.deals"
    sbTooltip="{{ 'lang.globals.showDeals' | translate }}"
  >
  </button>

</ng-container>

<!------------------------------

      Table-Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.sspContracts' | translate}}"
  [itemsData]="contracts"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'sspContracts'">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.id' | translate }}</th>
      <th>{{ 'lang.globals.identifier' | translate }}</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.sspName' | translate }}</th>
      <th>{{ 'lang.globals.modifiedAt' | translate }}</th>
      <th>{{ 'lang.globals.screenIdPrefix' |translate }}</th>
      <th>{{ 'lang.globals.screenIdSuffix' |translate }}</th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-contract>
    <tr>
      <td>
        {{ contract?.id }}
      </td>
      <td>
        {{ contract?.identifier }}
      </td>
      <td>
        {{ contract?.name }}
      </td>
      <td>
        <sb-comp-image-name-wrapper [image]="contract?.ssp?.primaryCompany?.logo?.url">
          <span firstLine>{{ contract?.ssp?.name }}</span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <sb-comp-display-modified [data]="contract"></sb-comp-display-modified>
      </td>
      <td>{{ contract?.screenIdPrefix }}</td>
      <td>{{ contract?.screenIdSuffix }}</td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="contract.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(contract, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper-new>
